class StylishCountdown extends HTMLElement {
  constructor() {
    super();
    this.timerInterval = null;
  }

  connectedCallback() {
    this.endDate = this.getAttribute('date');
    this.isDaily = this.hasAttribute('daily');
    this.showLabel = this.hasAttribute('show-label'); // Check for label attribute
    this.render();
    this.startTimer();
  }

  disconnectedCallback() {
    if (this.timerInterval) clearInterval(this.timerInterval);
  }

  getEndTime() {
    const now = new Date();
    if (this.isDaily) {
      const end = new Date(now);
      end.setHours(24, 0, 0, 0);
      return end.getTime();
    }
    return new Date(this.endDate).getTime();
  }

  render() {
      // Initial render
      this.innerHTML = '<div class="timer-wrapper">Loading...</div>';
  }

  startTimer() {
    const update = () => {
      const now = new Date().getTime();
      const endTime = this.getEndTime();
      const distance = endTime - now;

      if (distance < 0) {
        if(this.isDaily) {
           // Reset for daily
        } else {
           clearInterval(this.timerInterval);
           this.innerHTML = '<div class="timer-ended">Sale Ended</div>';
           return;
        }
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.updateDisplay(days, hours, minutes, seconds);
    };

    update();
    this.timerInterval = setInterval(update, 1000);
  }

  updateDisplay(days, hours, minutes, seconds) {
    const dd = String(days).padStart(2, '0');
    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');

    let html = '<div class="timer-wrapper">';
    
    // Add "Sale Ends in:" text if enabled
    if (this.showLabel) {
       html += `<span class="timer-prefix-text">Sale Ends in: </span>`;
    }

    if (days > 0) {
       html += `
        <div class="timer-block">
          <span class="timer-value">${dd}</span>
          <span class="timer-label">d</span>
        </div>
        <div class="timer-separator">:</div>`;
    }

    html += `
        <div class="timer-block">
          <span class="timer-value">${hh}</span>
          <span class="timer-label">h</span>
        </div>
        <div class="timer-separator">:</div>
        <div class="timer-block">
          <span class="timer-value">${mm}</span>
          <span class="timer-label">m</span>
        </div>
        <div class="timer-separator">:</div>
        <div class="timer-block">
          <span class="timer-value">${ss}</span>
          <span class="timer-label">s</span>
        </div>
      </div>`;

    this.innerHTML = html;
  }
}

customElements.define('stylish-countdown', StylishCountdown);
